import Cookies from 'universal-cookie';

const cookies = new Cookies();

/** Cookies */
export const cookie = (type, name, value, maxAge) => {

  const time24 = new Date(new Date().setHours(25));
  const time24stamp = time24.valueOf();
  const time24Date = new Date(time24stamp);

  const options = {
    path: '/',
    sameSite: true,
    secure: true,
    maxAge: maxAge === null ? 60 * 60 * 8 : maxAge,  // 24小時 86400 8小時 28800(秒)
    expires: time24Date  // 絕對過期日期
  }

  switch(type) {
    case 'get':
      return cookies.get(name);
    case 'set':
      cookies.set(name, value, options);
      break;
    case 'remove':
      cookies.remove(name, options);
      break;
    default:
      break;
  }

}
